module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<transition name='modal'>\n  <div class='modal-mask'>\n    <div class='modal-wrapper'>\n      <div class='modal-container' v-bind:class='{big: \"big\"}'>\n        <div class='modal-header'>\n          <slot name='header'>\n            default header\n          </slot>\n        </div>\n        <div class='modal-body'>\n          <slot name='body'></slot>\n        </div>\n        <div class='modal-footer'>\n          <slot name='footer'></slot>\n        </div>\n      </div>\n    </div>\n  </div>\n</transition>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
